import request from '@/utils/ai-request'

/**
 * 评估对话
 */
export function evaluateConversation(conversationId) {
  return request({
    url: `/evaluations/evaluate/${conversationId}`,
    method: 'post'
  })
}

/**
 * 获取评估结果
 */
export function getEvaluation(conversationId) {
  return request({
    url: `/evaluations/conversation/${conversationId}`,
    method: 'get'
  })
}
